<template>
        <img :src="logo"/>
</template>

<script>
    let ax = axios.create({
        baseURL: 'http://hessestudios.de/wp/wp-json/hessestudios/hessesettings'
    });
    export default {
        name: 'Logo',
        data(){
            return {
                logo : ""
            };
        },
        mounted(){
            ax.get().then(response => {
                this.logo = response.data.hesse_field_logo;
            });
        }
    }
</script>

